module.exports = __webpack_public_path__ + "img/logo_jfx.071a78d0.png";